import styled, { keyframes } from "styled-components";
import SelectArrowIcon from "../../../assets/images/select-arrow-icon.svg";

export const Wrapper = styled.div`
  background: #fff;
  min-height: 100vh;
`;

export const AppContent = styled.div`
  padding: 7.75rem 2rem 2rem;
  margin-left: 345px;
  position: relative;
  transition: all 0.3s ease;
  backface-visibility: hidden;
  min-height: calc(100% - 3.35rem);
  overflow: hidden;
  
  &.sidebar-wrapper{
    margin-left: 80px;
  }
`;

export const HeaderShadow = styled.div`
  padding-top: 2.2rem;

  left: 0;
  display: block;
  width: 100%;
  height: 102px;
  position: fixed;
  top: 0;
  z-index: 11;
  pointer-events: none;
`;

export const AppContainer = styled.div`
  width: 100%;
  
  margin-right: auto;
  margin-left: auto;
  .userDetailsRow {
    margin-bottom: 1.5rem;
  }
`;

export const AppUserList = styled.div`
  margin-bottom: 0;
  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid rgba(34, 41, 47, 0.125);
  border-radius: 0.428rem;
  transition: all 0.3s ease-in-out, background 0s, color 0s, border-color 0s;
  position: relative;
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
`;

export const AppUserListHead = styled.div`
  width: 100%;  
  position: relative;
  box-sizing: border-box;
  padding: 1.3rem 1.5rem;
  width: 100%;
  justify-content: space-between;
  background-color: #fff;
  min-height: 52px;
  flex-wrap: wrap;
  align-items: center;
  display: flex;
`;

export const ShowEntries = styled.div`
  color: #112233;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 400;
  align-items: center;
  display: flex;

  label {
    margin: 0;
    font-weight: 400;
  }

  .form-select {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    background-position: right 0.75rem center;
    padding: 0.571rem 2rem 0.571rem 1rem;
    background-color: #fff;
    background-image: url(${SelectArrowIcon});
    background-repeat: no-repeat;
    background-size: 15px 14px;
    border: 1px solid #DFDFDF;
    border-radius: 20px;
    display: block;
    font-family: "Poppins", sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.45;
    color: #112233;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none;
    width: 70px;
    outline: none;
    box-shadow: none;
    cursor: pointer;
    &:focus {
      border-color: #D43D88;
      box-shadow: none;
    }
  }
`;

export const ListHeadRightContent = styled.div`  
  align-items: center;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;

  .btn {
    background-color: #D43D88;
    cursor: pointer;
    text-align: center;
    border: 1px solid #D43D88;
    padding: 9px 20px;
    border-radius: 20px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #ffffff;
    font-family: "Poppins", sans-serif;
    box-shadow: none;
    outline: none;
    text-decoration: none;
    margin-left: 1rem;
    
    &:hover {
      background-color: transparent;
      color: #112233;
    }
    
    &:focus,
    &:active {
      background-color: #D43D88;
      color: #ffffff;
    }
  }
`;

export const UserListSearch = styled.div`
  color: #112233;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 400;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 7px;

  label {
    margin: 0;
    font-weight: 400;
    white-space: nowrap;
  }

  .searchField,
  div {
    margin: 0 0 0 0.5rem;
  }

  .form-control {
    padding: 10px 16px;
    background-color: #FFFFFF;
    background-clip: padding-box;
    border: 1px solid #DFDFDF;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
    color: #112233;
    width: 197px;
    max-width: 100%;
    outline: none;
    box-shadow: none;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
      box-shadow: none;
      border-color: #DFDFDF;
    }
    &:hover{
      background-color: #FFFFFF;
    }
  }
`;

export const AppUserTable = styled.div`
  .table-responsive {
    min-height: 400px;
  }
  .table {
    margin: 0;
  
    thead {
      tr {
        th {
          background-color: #F9FAFF;
          border-top: none;
          border-bottom: none;
          padding: 0.72rem 1.5rem;
          color: #112233;
          font-family: "Poppins", sans-serif;
          font-weight: 600;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          font-size: 12px;
          vertical-align: middle;
          white-space: nowrap;
          @media screen and (max-width: 1440px) {
            padding: 0.72rem 1.5rem;
        }
        }
      }
    }

    tr{
      td{
        padding: 0.72rem 1.5rem;
        color: #112233;
        font-family: "Poppins", sans-serif;
        font-size: 13px;
        line-height: 1.45;
        font-weight: 400;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        vertical-align: middle;
        white-space: nowrap;

        @media screen and (max-width: 1440px) {
          padding: 0.72rem 1.5rem;
        }
        span{display: block;
          padding-bottom: 6px;padding-left:5px;padding-right:5px;}
        .rolemanagment-main{
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          gap: 8px;
          .rolemanagment-inner{
            display:flex;
            align-items:center;
            gap: 10px;
          }
        }
      }

      
    }
  }

  .activeStatus,
  .inactiveStatus,
  .pendingStatus,
  .addStatus,
  .removeStatus {
    padding: 0.3rem 0.5rem;
    text-align: center;
    border-radius: 0.358rem;
    display: inline-block;
    font-size: 85%;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    vertical-align: baseline;
    font-family: "Poppins", sans-serif;
    text-transform: capitalize;
  }
  .activeStatus {
    background: rgba(40, 199, 111, 0.12);
    color: #28c76f;
  }
  .inactiveStatus {
    background: rgba(130, 134, 139, 0.12);
    color: #82868b;
  }
  .pendingStatus {
    background: rgba(255, 159, 67, 0.12);
    color: #ff9f43;
  }
  .addStatus {
    background: rgba(2, 45, 45, 0.65);
    color: #022D2D;
  }
  .removeStatus {
    background: rgba(234, 84, 85, 0.12);
    color: #ea5455;
  }
`;

export const AppListUser = styled.div`
  display: flex;
`;

export const AppListUserImg = styled.div`
  display: inline-block;
  width: 32px;
  min-width: 32px;
  height: 32px;
  border-radius: 50px;
  margin-right: 1rem;
  background: #f3f3f3;
  a,
  button {
    display: block;
    border-radius: 50px;
    border: none;
    padding: 0;
    width: 100%;
    height: 100%;
    background: transparent !important;
    box-shadow: none !important;
    outline: none;
    cursor: pointer;
  }
  img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
    object-fit: cover;
    object-position: top center;
    border-radius: 100px;
  }
`;

export const AppListUserInfo = styled.div`
  font-family: "Poppins", sans-serif;
  color: #888;
  font-size: 0.857rem;
  line-height: 1.45;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  display: flex;

  h3 {
    font-weight: 600;
    color: #112233;
    font-family: "Poppins", sans-serif;
    font-size: 13px;
    line-height: normal;
    margin-bottom: 0;
    text-align: left;
    a,
    button {
      text-decoration: none;
      display: inline-block;
      font-weight: inherit;
      color: #112233 !important;
      font-family: "Poppins", sans-serif;
      font-size: inherit;
      line-height: inherit;
      text-align: left;
      border: none;
      background: transparent !important;
      padding: 0;
      box-shadow: none !important;
      border-radius: 0;
      transition: all 0.35s ease 0s;
      &:hover {
        color: #112233 !important;
      }
    }
  }
  p {
    margin-bottom: 0;
  }
  .listUserName {
    color: #112233;
  }
`;

export const AppUserListAction = styled.div`
  .dropdown {
    margin: 0 auto;
    max-width: 150px;
    width: 100%;
    display: inline-block;
    vertical-align: middle;
  }
  .dropdown-toggle {
    color: #112233;
    line-height: 1;
    font-size: 14px;
    font-weight: 500;
    font-family: "Poppins", sans-serif;
    background: transparent;
    border: 1px solid transparent;
    box-shadow: none !important;
    outline: none;
    cursor: pointer;
    margin: 0;
    padding: 0.486rem 1rem;
    border-radius: 0.358rem;
    svg {
      vertical-align: top;
    }
    &::after {
      display: none;
    }
  }

  .dropdown-menu {
    background: #ffffff;
    box-shadow: 0 5px 25px rgba(34, 41, 47, 0.1);
    min-width: 140px;
    padding: 0.5rem 0;
    background-clip: padding-box;
    border: 1px solid rgba(34, 41, 47, 0.05);
    border-radius: 16px;
    margin: auto;
    left: auto !important;
    right: 0 !important;
    transform-origin-x: unset !important;

    .dropdown-item {
      border: none;
      border-radius: 0;
      letter-spacing: 0px;
      transition: none;
      padding: 0.65rem 1.28rem;
      background-color: transparent;
      cursor: pointer;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.4;
      color: #112233;
      white-space: nowrap;
      outline: none;
      text-decoration: none;
      align-items: center;
      display: flex;

      &:last-child {
        margin-bottom: 0;
      }
      svg {
        height: 16px;
        width: 16px;
        font-size: 16px;
        margin-right: 0.5rem;
      }
      &:hover,
      &:focus {
        color: #022D2D;
        background-color: #F9FAFF;
        svg {
          stroke: #022D2D;
        }
      }
      &:active {
        color: #022D2D;
        background-color: #F9FAFF;
        svg {
          stroke:#022D2D;
        }
      }
    }
  }
`;

export const PaginationWrap = styled.div`
  padding: 1.5rem 1.3rem;

  .ant-pagination {
    justify-content: flex-end;
    display: flex;
    li {
      margin: 0;
      background-color: #F8F8F8;
      border: none;
      .ant-pagination-item-link,
      a {
        height: 32px;
        width: 32px;
        margin: 0;
        padding: 0;
        text-align: center;
        color: #112233;
        border: none;
        border-radius: 0;
        background-color: #F8F8F8;
        line-height: 1.1;
        font-family: "Poppins", sans-serif;
        font-size: 13px;
        font-weight: 500;
        box-shadow: none !important;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        display: flex;
        transition: all 0.05s ease-in-out;
        white-space: nowrap;
        
        svg {
          transition: all 0.35s ease 0s;
          height: 12px;
          width: 12px;
          stroke: #112233;
        }
        &:hover {
          color: #D43D88;
          svg {
            stroke: #D43D88;
          }
        }

        @media (max-width: 565px) {
          height: 28px;
          width: 28px;
          line-height: 28px;
          font-size: 12px;
        }
      }

      &.ant-pagination-jump-prev,
      &.ant-pagination-jump-next {
        .ant-pagination-item-container {
          width: 100%;
          height: 100%;
          .ant-pagination-item-ellipsis {
            top: 6px;
            right: 0;
            bottom: 6px;
            color: #112233;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            font-family: "Poppins", sans-serif;
          }
          .ant-pagination-item-link-icon {
            color: #D43D88;
            width: 100%;
            height: 100%;
            align-items: center;
            justify-content: center;
            display: flex;
          }
        }
      }

      &:first-child {
        border-top-left-radius: 1.428rem;
        border-bottom-left-radius: 1.428rem;
        .ant-pagination-item-link,
        a {
          border-top-left-radius: 1.428rem;
          border-bottom-left-radius: 1.428rem;
        }
      }

      &:last-child {
        border-top-right-radius: 1.428rem;
        border-bottom-right-radius: 1.428rem;
        .ant-pagination-item-link,
        a {
          border-top-right-radius: 1.428rem;
          border-bottom-right-radius: 1.428rem;
        }
      }

      // &.ant-pagination-disabled:not(:first-child) {
      //   .ant-pagination-item-link,
      //   a {
      //     color: #3b3b3b;
      //   }
      // }

      &.ant-pagination-item-active {
        .ant-pagination-item-link,
        a {
          background: #D43D88;
          color: #ffffff;
          border-radius: 50px;
          cursor: default;
          svg {
            stroke: #fff;
          }
        }
      }

      &.ant-pagination-disabled {
        .ant-pagination-item-link,
        a {
          color: #b9b9c3;
          cursor: not-allowed;
          svg {
            stroke: #b9b9c3;
          }
          &:hover {
            background: transparent;
            color: #b9b9c3;
          }
        }
      }
    }
  }
`;

export const UserProfileBox = styled.div`
  background-color: #fff;
  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.05);
  background-clip: border-box;
  border-radius: 0.428rem;
  padding: 20px;
  margin-bottom: 0;
  text-align: center;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  display: flex;
  transition: all 0.3s ease-in-out, background 0s, color 0s, border-color 0s;
`;

export const UserProfileBoxImg = styled.div`
  border-radius: 0.357rem;
  margin: 0 auto 1.5rem;
  width: 110px;
  height: 110px;
  background: #f3f3f3;
  img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
    object-fit: cover;
    object-position: top center;
    border-radius: 0.357rem;
  }
`;

export const UserProfileName = styled.div`
  margin-bottom: 0.5rem;
  font-size: 1.286rem;
  font-weight: 500;
  line-height: 1.2;
  color: #112233;
  font-family: "Poppins", sans-serif;
`;

export const UserProfileUserName = styled.div`
  font-family: "Poppins", sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
  color: #112233;
  margin-bottom: 0.7rem;
`;

export const UserProfileBadge = styled.span`
  padding: 0.3rem 0.5rem;
  text-align: center;
  border-radius: 0.358rem;
  display: inline-block;
  font-size: 85%;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  vertical-align: baseline;
  font-family: "Poppins", sans-serif;
  text-transform: capitalize;

  &.activeStatus {
    background: rgba(40, 199, 111, 0.12);
    color: #28c76f;
  }
  &.inactiveStatus {
    background: rgba(130, 134, 139, 0.12);
    color: #82868b;
  }
  &.pendingStatus {
    background: rgba(255, 159, 67, 0.12);
    color: #ff9f43;
  }
  &.infoStatus {
    background: rgba(0, 207, 232, 0.12);
    color: #00cfe8;
  }
`;

export const UserProfileInfo = styled.div`
  background-color: #fff;
  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.05);
  background-clip: border-box;
  border-radius: 0.428rem;
  padding: 20px;
  margin-bottom: 0;
  position: relative;
  height: 100%;
  transition: all 0.3s ease-in-out, background 0s, color 0s, border-color 0s;

  .boxClose {
    position: absolute;
    right: 20px;
    top: 15px;
    border: none;
    padding: 0;
    border-radius: 30px;
    background: #fff;
    cursor: pointer;
    svg {
      width: 32px;
      height: 32px;
      stroke: #b9b9c3;
      transition: all 0.35s ease 0s;
    }
    &:hover {
      svg {
        stroke: #ea5455;
      }
    }
  }

  h2 {
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 1.285rem;
    line-height: 1.2;
    color: #112233;
    margin-bottom: 0;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    li {
      padding: 0 10px;
      width: 33.33%;
      margin: 1.75rem 0 0;
      font-family: "Poppins", sans-serif;
      font-size: 1rem;
      line-height: 1.5rem;
      font-weight: 400;
      color: #112233;
      h3 {
        font-family: "Poppins", sans-serif;
        font-size: 1.07rem;
        font-weight: 500;
        line-height: 1.2;
        color: #112233;
        margin-bottom: 0.5rem;
      }
      p {
        margin-bottom: 0;
      }
      a {
        color: inherit;
        text-decoration: none;
        transition: all 0.35s ease 0s;
      }
    }
  }
`;

export const PageLoader = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  background: rgba(59, 59, 59, 0.2);
  backdrop-filter: blur(3px);
  align-items: center;
  justify-content: center;
  display: flex;
  z-index: 9999;
  img {
    width: 64px;
    height: 64px;
    vertical-align: middle;
  }
`;

export const DataNotFound = styled.div`
  padding: 0.72rem 1.5rem;
  color: #112233;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  letter-spacing: 0.5px;
  font-size: 14px;
  line-height: 1.1;
  text-align: center;
  strong {
    font-weight: 600;
  }
`;

export const IconWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
`;

export const EditWrap = styled.div`
  color: #112233;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 5px;
  cursor: pointer;
  
  svg{
    max-width: 14px;
    max-height: 14px;
  }
`;